export const TranslationType = {
    DEPARTMENT: "DEPARTMENT"
};
